if (!window.customElements.get('product-sticky-atc')) {
  class ProductStickyAtc extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.product = this.closest('[data-product]');
      this.buyButtonWrapper = this.product?.querySelector('[data-buy-button-wrapper]');

      if (!this.product || !this.buyButtonWrapper) return;

      this.price = this.querySelector('[data-sticky-atc-price]');
      this.compareAtPrice = this.querySelector('[data-sticky-atc-compare-price]');
      this.variantTitle = this.querySelector('[data-sticky-atc-variant-title]');
      this.submitButton = this.querySelector('[data-sticky-atc-submit]');
      this.callToOrderButton = this.querySelector('[data-sticky-atc-call-to-order]');

      if (this.submitButton) {
        this.submitButton.addEventListener('click', () => this.submitForm());
      }

      if (this.callToOrderButton) {
        this.primaryCallToOrderButton = this.product.querySelector('[data-call-to-order-trigger]');

        if (this.primaryCallToOrderButton) {
          this.callToOrderButton.addEventListener('click', () => this.primaryCallToOrderButton.click());
        }
      }

      if (this.variantTitle && window.location.href.indexOf('?variant') === -1) {
        this.classList.add('py-3');
        this.variantTitle.innerHTML = '';
      }

      window.addEventListener('scroll', () => this.handlePosition());
    }

    submitForm() {
      const formSubmitButton = this.product.querySelector('button[type="submit"]');
      if(!formSubmitButton) return;
      formSubmitButton.click();
    }

    handlePosition() {
      const buyBoxBottom = this.buyButtonWrapper.getBoundingClientRect().bottom;
      this.classList.toggle('bottom-0', buyBoxBottom < 0);
    }

    validateOptionSelection() {
      const optionGroups = this.querySelectorAll('[data-option-group]');
      const selectedOptions = this.querySelectorAll('[data-option].selected');
      return selectedOptions && selectedOptions.length >= optionGroups.length;
    }

    updateVariantTitle(variant) {
      const optionsSelected = this.validateOptionSelection();

      if (optionsSelected) {
        this.classList.remove('py-3');

        if (variant) {
          this.variantTitle.innerText = variant.title
        } else {
          const selectedOptions = this.querySelectorAll('[data-option-group-label]');
          if (!selectedOptions) return;
          let unavailableVariantTitle = '';
          selectedOptions.forEach((option, index) => unavailableVariantTitle += `${option.innerText}${index + 1 < selectedOptions.length ? ' / ' : ''}`);
          this.variantTitle.innerText = unavailableVariantTitle;
        }
      } else {
        this.variantTitle.innerText = '';
      }
    }

    updateSubmitButton(text, disabled) {
      if (this.submitButton) {
        this.submitButton.textContent = text;
        this.submitButton.disabled = disabled;

        if (disabled) {
          this.submitButton.setAttribute('aria-disabled', 'true');
        } else {
          this.submitButton.removeAttribute('aria-disabled');
        }
      }
    }

    updateVariantPrice(variant) {
      if (!variant) {
        if (this.compareAtPrice) this.compareAtPrice.classList.add('hidden');
        return;
      }

      const priceCents = variant.price;
      const compareCents = variant.comparePrice ?? variant.compare_at_price;

      this.price.textContent = window.formatMoney(priceCents);

      const showCompare = typeof compareCents === 'number' && compareCents > priceCents;

      if (this.compareAtPrice) {
        if (showCompare) {
          this.compareAtPrice.textContent = window.formatMoney(compareCents);
          this.compareAtPrice.classList.remove('hidden');
          this.compareAtPrice.setAttribute('aria-hidden', 'false');
          this.price.classList.add('text-red');
        } else {
          this.compareAtPrice.classList.add('hidden');
          this.compareAtPrice.setAttribute('aria-hidden', 'true');
          this.price.classList.remove('text-red');
        }
      }
    }
  }

  window.customElements.define('product-sticky-atc', ProductStickyAtc);
}
